import api from './api';

export async function fetchAdminTemplates() {
  const response = await api.get('/api/admin/templates');
  return response.data;
}

export async function createAdminTemplate(payload) {
  const response = await api.post('/api/admin/templates', payload);
  return response.data;
}

export async function updateAdminTemplate(key, payload) {
  const response = await api.put(`/api/admin/templates/${encodeURIComponent(key)}`, payload);
  return response.data;
}

export async function deleteAdminTemplate(key) {
  const response = await api.delete(`/api/admin/templates/${encodeURIComponent(key)}`);
  return response.data;
}

export async function fetchEmailTemplates() {
  const response = await api.get('/api/admin/email-templates');
  return response.data;
}

export async function createEmailTemplate(payload) {
  const response = await api.post('/api/admin/email-templates', payload);
  return response.data;
}

export async function updateEmailTemplate(key, payload) {
  const response = await api.put(`/api/admin/email-templates/${encodeURIComponent(key)}`, payload);
  return response.data;
}

export async function deleteEmailTemplate(key) {
  const response = await api.delete(`/api/admin/email-templates/${encodeURIComponent(key)}`);
  return response.data;
}

export async function fetchAppSettings() {
  const response = await api.get('/api/admin/app-settings');
  return response.data;
}

export async function updateAppSettings(settings) {
  const response = await api.put('/api/admin/app-settings', { settings });
  return response.data;
}

export async function resetAppSetting(key) {
  const response = await api.post(`/api/admin/app-settings/${encodeURIComponent(key)}/reset`);
  return response.data;
}

export async function fetchAiUsage(limit = 100) {
  const response = await api.get('/api/admin/ai-usage', { params: { limit } });
  return response.data;
}
